import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatError } from "@/lib/api";
import { ADMIN_BASE } from "@/lib/brand";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to={ADMIN_BASE} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate(ADMIN_BASE);
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] p-4 relative overflow-hidden noise-overlay" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="relative bg-white max-w-md w-full p-10 border-l-8 border-[#E65C00]">
        <div className="font-heading font-black text-3xl uppercase tracking-tight">TARA ADMIN</div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#E65C00] mt-1">CONTROL ROOM</div>
        <p className="text-gray-600 mt-5 text-sm">Sign in to manage products, content and leads.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] font-bold text-gray-500">Email</label>
            <div className="relative mt-2">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-gray-300 focus:outline-none focus:border-[#E65C00]"
                data-testid="admin-login-email"
              />
            </div>
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.2em] font-bold text-gray-500">Password</label>
            <div className="relative mt-2">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-3 py-3 border border-gray-300 focus:outline-none focus:border-[#E65C00]"
                data-testid="admin-login-password"
              />
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
